import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de resposta: repassa o erro original para quem chamou tratar
api.interceptors.response.use(
  res => res,
  err => Promise.reject(err)
);

export default api;
